import { render } from "./ScriptIcon.vue?vue&type=template&id=082fc358"
import script from "./ScriptIcon.vue?vue&type=script&lang=js"
export * from "./ScriptIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__